import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const usePlanLimits = () => {
  const [limits, setLimits] = useState(null);

  const fetchLimits = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await axios.get(`${API}/api/subscription/limits`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLimits(res.data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { fetchLimits(); }, [fetchLimits]);

  const checkCanAdd = useCallback(async (resource) => {
    const token = localStorage.getItem('token');
    if (!token) return { allowed: true };
    try {
      const res = await axios.get(`${API}/api/subscription/can-add/${resource}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.data.allowed) {
        toast.error(res.data.message || `Upgrade required to add more ${resource}`, {
          duration: 6000,
          action: {
            label: 'Upgrade',
            onClick: () => window.location.href = '/subscription',
          },
        });
      }
      return res.data;
    } catch {
      return { allowed: true };
    }
  }, []);

  const getLimitInfo = useCallback((resource) => {
    if (!limits || !limits[resource]) return null;
    return limits[resource];
  }, [limits]);

  return { limits, checkCanAdd, getLimitInfo, refresh: fetchLimits };
};

export default usePlanLimits;
